module.exports = __webpack_public_path__ + "img/Toph-256.d6e59e44.png";